import { type GeoLocation, type GeoLocationType } from '@smg-real-estate/geo-libs';

const INDEXABLE_LOCATION_TYPES: GeoLocationType[] = [
  'canton',
  'district',
  'region',
  'municipality',
  'place',
];

export function isPageIndexable(
  locations: GeoLocation[] | undefined,
  currentPage?: number,
): boolean {
  if (currentPage === undefined || currentPage < 1 || currentPage > 5) return false;

  if (locations === undefined) return false;

  if (locations.length === 0) return true;

  if (locations.length > 1) return false;

  return INDEXABLE_LOCATION_TYPES.includes(locations[0].type);
}
